import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import { getAppContext } from '../../util/decorators';
import { formatHeadingText } from '../../util/formatSportHeadingText';
import { compose } from 'recompose';
import EnetpulseWidget from '../EnetpulseWidget.jsx';
import PageHeading from '../PageHeading.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import sportConfig from '../../config/sports';
//enetpulseId: _.get(sportConfig, `${state.country}.${state.mappedSportRouteParam}.id`),

//let enetpulseId_test = _.get(sportConfig, `dk.${state.mappedSportRouteParam}.id`);
//console.log(`enetpulseId countryID:  ` + `${state.country}.${state.mappedSportRouteParam}.id`);
//country: state.country,
const mapStateToProps = state => ({
  enetpulseId: _.get(sportConfig, `dk.${state.mappedSportRouteParam}.id`),
  mappedSportRouteParam: state.mappedSportRouteParam,
  sport: state.routeParams.sports,
  country: `dk`,
});
//console.log(`livescore mapStateToProps:  ` + JSON.stringify(mapStateToProps));

const LiveScore = ({mappedSportRouteParam, enetpulseId, app, sport, country}) =>
  <PageWithSidebars>
    <section className="score-center-page">
      <PageHeading firstPart={formatHeadingText(country, sport)} secondPart={app.t('LiveScoreIndex.heading')} />
      <EnetpulseWidget sport={mappedSportRouteParam} widgetType="livescore" params={`${enetpulseId}/0/basic_h2h/0/0`} className="margin-top"/>
    </section>
  </PageWithSidebars>;

LiveScore.propTypes = {
  route: React.PropTypes.object.isRequired,
  enetpulseId: React.PropTypes.string,
  app: React.PropTypes.object,
};

export default compose(
  connect(mapStateToProps),
  linkTag2Initializer(),
  getAppContext
)(LiveScore);



// WEBPACK FOOTER //
// ./src/component/WidgetPages/LiveScore.jsx